import Image from "next/image";
import type { ComponentProps } from "react";

import { Link } from "@/i18n/navigation";

type LogoProps = Omit<ComponentProps<typeof Link>, "href" | "aria-label"> & {
  ariaLabel: string;
  href?: string;
  scroll?: boolean;
  compact?: boolean;
};

export function Logo({ ariaLabel, href = "/app", scroll, compact = false, ...linkProps }: LogoProps) {
  return (
    <Link
      {...linkProps}
      href={href}
      scroll={scroll}
      className="group inline-flex items-center gap-2.5 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      aria-label={ariaLabel}
    >
      <Image
        src={compact ? "/favicon.svg" : "/LogoHorizontal.svg"}
        alt="Aulyn"
        width={compact ? 512 : 1218}
        height={compact ? 512 : 487}
        priority
        className={`${compact ? "size-8" : "h-9 w-auto"} transition-opacity group-hover:opacity-85`}
      />
    </Link>
  );
}
